import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import noEventImage from "../../../assets/noEventImage.svg";
import profile_img from "../../../assets/avatar_placeholder.svg";
import {
  TwContainer,
  TwListMoreButton,
  TwMainLayout,
  TwMoreOptions,
} from "../../../components/tailwind";
import { useLocalStorage } from "../../../hooks";
import { useToast } from "../../../provider/ToastProvider";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";
import {
  loadingState,
  setGlobalLoading,
} from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import {
  getUrlForBookings,
  getUrlForClasses,
} from "../../../utils/confighelpers";
import moment from "moment";

export default function TransactionsList({ navigation, profileFor, title }) {
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loadingReduxState = useSelector(loadingState);
  const dashboardReduxState = useSelector(dashboardState);
  const [userToken] = useLocalStorage("userToken");
  const [loading, setLoading] = React.useState(false);
  const [transactionsList, setTransactionsList] = React.useState([]);
  const [listPageNumber, setListPageNumber] = React.useState(1);
  const [showViewMore, setShowViewMore] = React.useState(false);

  React.useEffect(() => {
    (async () => {
      await getAllTransactions(listPageNumber);
    })(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userToken, dashboardReduxState.updateSessionComp, listPageNumber]);

  const getAllTransactions = async (page = 1) => {
    setShowViewMore(false);
    let mgProducts = [];
    const config = {
      method: "get",
      url: `${getUrlForBookings()}getAllTransactions?page=${page}&limit=10&listFor=class`,
    };
    // dispatch(setGlobalLoading(true));
    setLoading(true);
    const productRequest = await axiosInstance(config);
    setLoading(false);
    // dispatch(setGlobalLoading(false));
    if (productRequest.status === 200) {
      // console.log("productRequest.data.data", productRequest.data.data.data);
      console.log(
        "productRequest.data.statusCode",
        productRequest.data.statusCode,
      );

      if (
        productRequest.data.statusCode === 200 &&
        productRequest.data.data.data.length
      ) {
        if (productRequest.data.data.totalCount > 10) {
          setShowViewMore(true);
        }
        console.log("productRequest.data.data", productRequest.data.data.data);
        if (listPageNumber > 1) {
          setTransactionsList([
            ...transactionsList,
            ...productRequest.data.data.data,
          ]);
        } else {
          setTransactionsList(productRequest.data.data.data);
        }
      }
    }
  };

  return (
    <TwMainLayout
      headTitle={title}
      headActions={[
        <div className={"flex flex-col-reverse sm:flex-row gap-3 w-full"}>
          <div className={"flex gap-3"}></div>
          <div className={"flex flex-row items-center gap-3"}></div>
        </div>,
      ]}
      children={
        <TwContainer className="">
          <div className={"w-full"}>
            <div className={"flex flex-col gap-4 md:col-span-2"}>
              <div className="overflow-x-auto">
                <div className="inline-block min-w-full py-2 align-middle sm:px-1">
                  <div className="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-300">
                      <thead className="bg-gray-50">
                        <tr>
                          <th
                            scope="col"
                            className="py-3.5 pl-4 pr-3 text-left text-sm font-extrabold text-gray-500 sm:pl-10"
                          >
                            Customer
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500"
                          >
                            Item Bought
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500"
                          >
                            Purchase Date
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3.5 text-left text-sm font-extrabold text-gray-500"
                          >
                            Amount Paid
                          </th>
                          <th
                            scope="col"
                            className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                          >
                            <span className="sr-only">Detailed Report</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {transactionsList.length > 0
                          ? transactionsList.map((data) => {
                              let moreBtnList = [];
                              // [
                              //           <TwListMoreButton
                              //             className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
                              //             onClick={() => {
                              //               handleSessionClick();
                              //               // handleDateTimeModalOpen();
                              //             }}
                              //           >
                              //             View
                              //           </TwListMoreButton>,
                              //         ]
                              if (
                                data?.stripeTransactionDetail?.receiptUrl &&
                                data?.stripeTransactionDetail?.receiptUrl !== "" &&
                                data?.stripeTransactionDetail?.receiptUrl != null
                              ) {
                                moreBtnList.push(
                                  <a
                                    href={data?.stripeTransactionDetail?.receiptUrl}
                                    rel="noreferrer"
                                    target="_blank"
                                    className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
                                  >
                                    View Receipt
                                  </a>,
                                );
                              }

                              // return (
                              //   <tr key={data._id}>
                              //     <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                              //       <div className="flex justify-start items-center [min-w-4/5] w-full line-clamp-1">
                              //         <div className="flex-none">
                              //         </div>
                              //         <div className="flex-1 min-w-0 line-clamp-1">
                              //           {/* <div>{cutString(row?.studentName, 10, true)}</div> */}
                              //           <div className=" line-clamp-1">{data.customer_name}</div>
                              //           <div className="text-primary line-clamp-1">{data.customer_id}</div>
                              //         </div>
                              //       </div>
                              //     </td>
                              //     <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{data.line_items.length > 0 ? data.line_items[0]?.description : ""}</td>
                              //     <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{moment(data.created).format('DD-MM-YY')}</td>
                              //     <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">€{parseFloat(parseFloat(data.amount_total)).toFixed(2)}</td>
                              //     <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                              //       {data.receipt_url != undefined && data.receipt_url != null && (<TwMoreOptions
                              //         options={moreBtnList} />)}
                              //     </td>
                              //   </tr>
                              // )
                              return (
                                <tr key={data._id}>
                                  <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                    <div className="flex justify-start items-center [min-w-4/5] w-full line-clamp-1">
                                      <div className="flex-none">
                                        {data.studentDetail?.profilePic ? (
                                          <img
                                            className="size-8 rounded-full mr-3"
                                            src={data.studentDetail.profilePic}
                                            alt={``}
                                          />
                                        ) : (
                                          <img
                                            className="size-8 rounded-full mr-3"
                                            src={profile_img}
                                            alt={``}
                                          />
                                        )}
                                      </div>
                                      <div className="flex-1 min-w-0 line-clamp-1">
                                        {/* <div>{cutString(row?.studentName, 10, true)}</div> */}
                                        <div className=" line-clamp-1">
                                          {data.studentDetail.fullName}
                                        </div>
                                        <div className="text-primary line-clamp-1">
                                          {data.studentDetail?.stripeCustomerId
                                            ? data.studentDetail
                                                ?.stripeCustomerId
                                            : data.studentDetail?.countryCode
                                              ? data.studentDetail.countryCode +
                                                " " +
                                                data.studentDetail.phoneNumber
                                              : "" +
                                                data.studentDetail?.username}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    {data.transactionsFor == "product" &&
                                    data.userpurchasesDetail !== undefined
                                      ? data.userpurchasesDetail.selectedPassDetail?.productName ||
                                        data.userpurchasesDetail.selectedPassDetail?.passName ||
                                        ""
                                      : data.className +
                                        " (" +
                                        data.ticketsBought[0].ticketType +
                                        ")"}
                                  </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    {moment(data.createdAt).format("DD-MM-YY")}
                                  </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    €
                                    {parseFloat(
                                      parseFloat(data?.userpurchasesDetail?.totalStripeAmount || 0),
                                      parseFloat(data?.amount || 0),
                                    ).toFixed(2)}
                                  </td>
                                  <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                    {data?.stripeTransactionDetail?.receiptUrl && data?.stripeTransactionDetail?.receiptUrl !== "" &&
                                      data?.stripeTransactionDetail?.receiptUrl != null && (
                                        <TwMoreOptions options={moreBtnList} />
                                      )}
                                  </td>
                                </tr>
                              );
                              return (
                                <tr key={data._id}>
                                  <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                    <div className="flex justify-start items-center [min-w-4/5] w-full line-clamp-1">
                                      <div className="flex-none">
                                        {data.studentDetail?.profilePic ? (
                                          <img
                                            className="size-8 rounded-full mr-3"
                                            src={data.studentDetail.profilePic}
                                            alt={``}
                                          />
                                        ) : (
                                          <img
                                            className="size-8 rounded-full mr-3"
                                            src={profile_img}
                                            alt={``}
                                          />
                                        )}
                                      </div>
                                      <div className="flex-1 min-w-0 line-clamp-1">
                                        {/* <div>{cutString(row?.studentName, 10, true)}</div> */}
                                        <div className=" line-clamp-1">
                                          {data.studentDetail.fullName}
                                        </div>
                                        <div className="text-primary line-clamp-1">
                                          {data.studentDetail?.stripeCustomerId
                                            ? data.studentDetail
                                                ?.stripeCustomerId
                                            : data.studentDetail?.countryCode
                                              ? data.studentDetail.countryCode +
                                                " " +
                                                data.studentDetail.phoneNumber
                                              : "" +
                                                data.studentDetail?.username}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    {data.type == "purchase"
                                      ? data.selectedPassDetail?.productName ||
                                        data.selectedPassDetail?.passName ||
                                        ""
                                      : data.className +
                                        " (" +
                                        data.ticketsBought[0].ticketType +
                                        ")"}
                                  </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    {moment(data.createdAt).format("DD-MM-YY")}
                                  </td>
                                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                    €
                                    {parseFloat(
                                      parseFloat(data.totalStripeAmount),
                                    ).toFixed(2)}
                                  </td>
                                  <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                    {data.receipt_url &&
                                      data.receipt_url != null && (
                                        <TwMoreOptions options={moreBtnList} />
                                      )}
                                  </td>
                                </tr>
                              );
                            })
                          : loading === false && (
                              <tr>
                                <td
                                  colSpan={5}
                                  className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center"
                                >
                                  No Transaction Found
                                </td>
                              </tr>
                            )}
                        {loading === true ? (
                          <tr>
                            <td
                              colSpan={5}
                              className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6 text-center"
                            >
                              Loading...
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {showViewMore ? (
              <div className={"flex flex-row justify-center my-4"}>
                <button
                  className={
                    "text-white text-sm cursor-pointer bg-blue-bz rounded-lg p-2 px-5"
                  }
                  onClick={() => {
                    setListPageNumber(listPageNumber + 1);
                  }}
                >
                  View More
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </TwContainer>
      }
    />
  );
}
